var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSupportModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 116,
    viewBox: "0 0 121 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 116
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 0H0v116h121z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.184 0C31.262 0 5.374 25.966 5.374 58c0 12.907 4.205 24.83 11.31 34.465-1.252 3.347-2.863 6.555-4.94 9.125-8.018 9.914-11.75 9.914-11.75 9.914s16.37 1.345 31.62-4.913A57.4 57.4 0 0 0 63.178 116c31.929 0 57.809-25.966 57.809-58S95.113 0 63.184 0",
    fill: "#3D82F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.059 84.521c14.933 0 27.038-12.145 27.038-27.128 0-14.982-12.105-27.127-27.038-27.127S37.02 42.41 37.02 57.393s12.106 27.128 27.039 27.128",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.524 18.704c15.408 0 27.951 12.307 28.398 27.664a.824.824 0 0 1-.824.84h-3.355a.823.823 0 0 1-.818-.808c-.422-12.598-10.737-22.682-23.394-22.682S40.558 33.802 40.136 46.4a.824.824 0 0 1-.818.809h-3.355a.824.824 0 0 1-.824-.84c.44-15.351 12.984-27.665 28.398-27.665",
    fill: "#0D63ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.69 91.102c0-.455.37-.828.824-.828h14.778v.19c7.47-3.587 12.751-11.025 13.28-19.759V44.058c0-.48.403-.86.881-.828 7.817.455 14.01 6.959 14.01 14.916a14.94 14.94 0 0 1-9.535 13.942.83.83 0 0 0-.529.676c-1.277 10.444-8.188 19.14-17.585 22.941a.83.83 0 0 0-.522.764.83.83 0 0 1-.825.827H58.514a.83.83 0 0 1-.825-.827v-5.374zM39.795 72.234a.83.83 0 0 1-.882.827c-7.817-.455-14.01-6.959-14.01-14.915 0-7.957 6.2-14.461 14.01-14.916a.83.83 0 0 1 .882.828z",
    fill: "#0D63ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36 66.98v.713c0 3.498-2.827 6.334-6.314 6.334s-6.313-2.836-6.313-6.334v-.713",
    stroke: "#050505",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h121v116H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportModal);
export default __webpack_public_path__ + "static/media/SupportModal.3a19f654a87b2ccf87ee858fc114a1ea.svg";
export { ForwardRef as ReactComponent };